import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    try {
      await store.dispatch('auth/fetchUser')
    } catch (e) { }
  }

  if (store.getters['auth/check'] && (!to.name || to.name === 'login')) {
    next({ name: 'home' })
  } else {
    next()
  }

  if (store.getters['auth/check'] && store.getters['auth/user'].role !== 3) {
    if (to.name === 'users' || to.name === 'user' || to.name === 'orders') {
      next({ name: 'home' })
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/check-auth.js